import { Howl } from 'howler'

export default class HowlerService {
    constructor (totalVolume) {
        this._playlist = []
        this.totalVolume = totalVolume
        this._isPlaying = false
    }

    setTotalVolume (totalVolume) {
        this.totalVolume = totalVolume
    }

    addSounds (soundsArray) {
        this._playlist = this._playlist.concat(soundsArray)
    }

    async playAllSounds () {
        if (!this._isPlaying) {
            this._isPlaying = true
            while (this._playlist.length > 0) {
                await this._playSound(this._playlist.shift())
            }
            this._isPlaying = false
        }
    }

    async _playSound (sound) {
        if (!sound) {
            return
        }
        return new Promise((resolve) => {
            const howl = new Howl({
                src: sound,
                preload: true,
                volume: this.totalVolume,
                onend () {
                    return resolve()
                },
                onloaderror () {
                    return resolve()
                },
                onplayerror () {
                    return resolve()
                }
            })

            howl.play()
        })
    }
}
